/* vibe-reels.js — Wanelo Vibes: full-screen vertical reel feed (WB Vibes / TikTok
   style). Reads window.VIBE_CLIPS (built by build_vibe_clips.py: {v, poster, url,
   title}) and renders a vertical scroll-snap feed. The active reel autoplays
   (muted, inline); a single product panel (fixed right on desktop / bottom on
   mobile) updates to the active reel's product, fetched lazily from /products.js.
   Add-to-cart posts to /cart/add.js. Lazy <video> src (active ±1) keeps it light
   even with 50+ clips. */
(function () {
  if (window.__VIBE_REELS_BOOTED__) return;
  window.__VIBE_REELS_BOOTED__ = true;

  function boot() {
    var root = document.querySelector('[data-vreels]');
    if (!root) return;
    var track = root.querySelector('[data-vreels-track]');
    var panel = root.querySelector('[data-vreels-product]');
    var clips = (window.VIBE_CLIPS || []).slice();
    // shuffle (Fisher-Yates) so the feed differs every visit — it was always the
    // same fixed order before because VIBE_CLIPS is a static array.
    for (var _i = clips.length - 1; _i > 0; _i--) { var _j = Math.floor(Math.random() * (_i + 1)); var _t = clips[_i]; clips[_i] = clips[_j]; clips[_j] = _t; }
    if (!track || !clips.length) {
      root.classList.add('vreels--empty');
      return;
    }

    var ROUTE = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var muted = true;
    var prodCache = {};
    var slides = [];
    var active = -1;

    function handleOf(url) {
      var m = String(url || '').match(/\/products\/([a-z0-9\-]+)/i);
      return m ? m[1] : null;
    }
    function money(cents) {
      try {
        var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
        return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: cur }).format((cents || 0) / 100);
      } catch (_) { return '$' + ((cents || 0) / 100).toFixed(2); }
    }

    /* ---- build slides ---- */
    clips.forEach(function (c, i) {
      var slide = document.createElement('section');
      slide.className = 'vreel';
      slide.setAttribute('data-vreel', i);
      var v = document.createElement('video');
      v.className = 'vreel__video';
      v.muted = true; v.loop = true; v.playsInline = true;
      // iOS Safari ONLY autoplays when the `muted` ATTRIBUTE (not just the property)
      // and playsinline are present at load — without this the video never starts.
      v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.setAttribute('webkit-playsinline', ''); v.setAttribute('autoplay', '');
      v.preload = 'metadata';
      v.poster = c.poster || '';
      v.setAttribute('data-src', c.v || '');
      slide.appendChild(v);
      // tap-to-pause + overlay
      var ov = document.createElement('div');
      ov.className = 'vreel__overlay';
      ov.innerHTML = '<div class="vreel__title">' + (c.title ? esc(c.title) : 'Wanelo Clip') + '</div>';
      slide.appendChild(ov);
      track.appendChild(slide);
      slides.push({ el: slide, video: v, clip: c, loaded: false });
    });

    function esc(s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; }
    function svgMute() { return '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2"><path d="M11 5 6 9H2v6h4l5 4z"/><line x1="23" y1="9" x2="17" y2="15"/><line x1="17" y1="9" x2="23" y2="15"/></svg>'; }
    function svgUnmute() { return '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2"><path d="M11 5 6 9H2v6h4l5 4z"/><path d="M15.5 8.5a5 5 0 0 1 0 7"/><path d="M18.5 5.5a9 9 0 0 1 0 13"/></svg>'; }

    function loadSrc(idx) {
      var s = slides[idx]; if (!s || s.loaded) return;
      var src = s.video.getAttribute('data-src');
      if (src) { s.video.preload = 'auto'; s.video.src = src; s.loaded = true; }
    }
    // mobile browsers often reject the first play() until enough data buffers —
    // retry once the video signals it can play.
    function playRobust(v) {
      var p = v.play();
      if (p && p.catch) p.catch(function () {
        v.addEventListener('canplay', function once() { v.removeEventListener('canplay', once); v.play().catch(function () {}); });
      });
    }

    /* ---- product panel ---- */
    function renderProduct(clip) {
      var h = handleOf(clip.url);
      if (!h) {
        panel.innerHTML =
          '<div class="vreels__pcard vreels__pcard--generic">' +
          '<div class="vreels__pkicker">Wanelo Vibes</div>' +
          '<div class="vreels__ptitle">' + esc(clip.title || 'Discover more') + '</div>' +
          '<a class="vreels__pbtn" href="' + esc(clip.url || ROUTE) + '">Explore the feed</a>' +
          '</div>';
        return;
      }
      if (prodCache[h]) { paint(prodCache[h], clip); return; }
      // instant: show the clip title right away, enrich (image/price/CTA) when fetch lands
      panel.innerHTML = '<div class="vreels__pcard"><div class="vreels__pskel" style="height:200px"></div><div class="vreels__pbody"><div class="vreels__ptitle">' + esc(clip.title || '') + '</div></div></div>';
      fetch(ROUTE + 'products/' + h + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) { if (p) { prodCache[h] = p; if (active >= 0 && slides[active] && slides[active].clip === clip) paint(p, clip); } })
        .catch(function () {});
    }

    function prefetch(idx) {
      var s = slides[idx]; if (!s) return;
      var h = handleOf(s.clip.url); if (!h || prodCache[h]) return;
      fetch(ROUTE + 'products/' + h + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) { if (p) prodCache[h] = p; }).catch(function () {});
    }

    function paint(p, clip) {
      var img = (p.featured_image || (p.images && p.images[0]) || '');
      if (img && img.indexOf('//') === 0) img = 'https:' + img;
      var vid = (p.variants && p.variants[0] && p.variants[0].id) || '';
      var onSale = p.compare_at_price && p.compare_at_price > p.price;
      panel.innerHTML =
        '<div class="vreels__pcard">' +
        '<a class="vreels__pmedia" href="' + esc(p.url) + '">' + (img ? '<img src="' + esc(img.replace(/(\.[a-z]+)(\?|$)/i, '_480x$1$2')) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') + '</a>' +
        '<div class="vreels__pbody">' +
        '<a class="vreels__ptitle" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
        '<div class="vreels__pprice"><span class="now">' + money(p.price) + '</span>' + (onSale ? '<span class="old">' + money(p.compare_at_price) + '</span>' : '') + '</div>' +
        '<button class="vreels__pbtn" data-add="' + vid + '"' + (p.available ? '' : ' disabled') + '>' + (p.available ? 'Add to cart' : 'Sold out') + '</button>' +
        '<a class="vreels__plink" href="' + esc(p.url) + '">View details</a>' +
        '</div></div>';
    }

    /* ---- add to cart ---- */
    panel.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-add]'); if (!btn) return;
      var id = btn.getAttribute('data-add'); if (!id) return;
      e.preventDefault();
      var label = btn.textContent; btn.textContent = 'Adding…'; btn.disabled = true;
      fetch(ROUTE + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'same-origin',
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
      }).then(function (r) { return r.json(); }).then(function () {
        btn.textContent = '✓ Added';
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 1600);
      }).catch(function () { btn.textContent = label; btn.disabled = false; });
    });

    /* ---- sound ON by default: videos autoplay MUTED (mobile/desktop browsers
       block autoplay-with-sound), then unmute on the FIRST browsing gesture
       (scroll/touch/key) — which happens immediately as the user swipes, so
       sound effectively starts right away without breaking autoplay. ---- */
    var soundOn = false;
    function enableSound() {
      if (soundOn) return; soundOn = true; muted = false;
      slides.forEach(function (s) { s.video.muted = false; });
      if (active >= 0 && slides[active]) { var p = slides[active].video.play(); if (p && p.catch) p.catch(function () {}); }
    }
    ['touchstart', 'wheel', 'keydown', 'scroll'].forEach(function (ev) {
      (ev === 'scroll' ? track : root).addEventListener(ev, enableSound, { passive: true });
    });
    // tap the video to pause / resume (also unmutes)
    track.addEventListener('click', function (e) {
      enableSound();
      var sl = e.target.closest('.vreel'); if (!sl) return;
      var vd = slides[+sl.getAttribute('data-vreel')] && slides[+sl.getAttribute('data-vreel')].video;
      if (vd) { vd.paused ? vd.play().catch(function () {}) : vd.pause(); }
    });

    /* ---- activation via IntersectionObserver ---- */
    function setActive(idx) {
      if (idx === active) return;
      active = idx;
      slides.forEach(function (s, i) {
        if (i === idx) {
          loadSrc(i); loadSrc(i + 1); loadSrc(i - 1 < 0 ? 0 : i - 1);
          s.video.muted = muted;
          playRobust(s.video);
          s.el.classList.add('is-active');
        } else {
          s.video.pause();
          s.el.classList.remove('is-active');
        }
      });
      renderProduct(slides[idx].clip);
      prefetch(idx + 1); prefetch(idx - 1);   // warm neighbours so the next reel's product is instant
      // reflect in URL hash (shareable, no reload)
      try { history.replaceState(null, '', '#v' + idx); } catch (_) {}
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting && en.intersectionRatio >= 0.6) {
          setActive(+en.target.getAttribute('data-vreel'));
        }
      });
    }, { threshold: [0.6], root: track });
    slides.forEach(function (s) { io.observe(s.el); });

    /* ---- nav: arrows + keyboard ---- */
    function go(delta) {
      var n = Math.max(0, Math.min(slides.length - 1, active + delta));
      slides[n].el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    root.querySelectorAll('[data-vreels-nav]').forEach(function (b) {
      b.addEventListener('click', function () { go(b.getAttribute('data-vreels-nav') === 'next' ? 1 : -1); });
    });
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown' || e.key === 'PageDown') { e.preventDefault(); go(1); }
      else if (e.key === 'ArrowUp' || e.key === 'PageUp') { e.preventDefault(); go(-1); }
      else if (e.key === 'm' || e.key === 'M') { soundOn = true; muted = !muted; slides.forEach(function (s) { s.video.muted = muted; }); }
    });

    /* ---- deep link (#vN) ---- */
    var start = 0;
    var mh = (location.hash || '').match(/^#v(\d+)$/);
    if (mh) start = Math.min(slides.length - 1, +mh[1]);
    if (start > 0) slides[start].el.scrollIntoView({ block: 'start' });
    setActive(start);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
